/**
 * Temporary shared resolver: matches ApiService hosted-base rules
 * (`restaurant_api_version === 'azure'`, `environment.production`, TLD, `devApiUrls`).
 * Import `resolveHostedUrl` in each caller until a single long-term approach replaces this.
 */
import { environment } from '../../environments/environment';
import {
  myProdApiUrls,
  idProdApiUrls,
  thProdApiUrls,
  devApiUrls,
} from './api-urls';

export type HostedUrlKey = keyof typeof myProdApiUrls;

function getAzureRegionMap(): typeof myProdApiUrls | null {
  if (typeof window === 'undefined' || !window.location?.hostname) {
    return null;
  }
  const h = window.location.hostname.toLowerCase();
  if (h.endsWith('.th')) {
    return thProdApiUrls;
  }
  if (h.endsWith('.id')) {
    return idProdApiUrls;
  }
  if (h.endsWith('.ai')) {
    return myProdApiUrls;
  }
  return null;
}

function defaultGetItem(key: string): string | null {
  try {
    return typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null;
  } catch {
    return null;
  }
}

/**
 * @param getItem optional override (e.g. `LocalStorageService.get`) for DI contexts.
 */
export function resolveHostedUrl(
  key: HostedUrlKey,
  getItem: (key: string) => string | null = defaultGetItem
): string {
  if (getItem('restaurant_api_version') !== 'aws') {
    return environment[key];
  }
  if (!environment.production) {
    return devApiUrls[key];
  }
  const region = getAzureRegionMap();
  if (region) {
    return region[key];
  }
  return environment[key];
}
